import React, { useState, useRef, useEffect } from 'react';

const CustomSelect = ({ value, onChange, options, className }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [openUpward, setOpenUpward] = useState(false);
    const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0, width: 0 });
    const selectRef = useRef(null);

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (selectRef.current && !selectRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    // Calculate dropdown position and determine direction
    useEffect(() => {
        if (isOpen && selectRef.current) {
            const rect = selectRef.current.getBoundingClientRect();
            const spaceBelow = window.innerHeight - rect.bottom;
            const spaceAbove = rect.top;
            const dropdownHeight = options.length * 40; // Approximate height per option

            // If not enough space below but more space above, open upward
            if (spaceBelow < dropdownHeight && spaceAbove > spaceBelow) {
                setOpenUpward(true);
                setDropdownPosition({
                    bottom: window.innerHeight - rect.top + 4,
                    left: rect.left,
                    width: rect.width
                });
            } else {
                setOpenUpward(false);
                setDropdownPosition({
                    top: rect.bottom + 4,
                    left: rect.left,
                    width: rect.width
                });
            }
        }
    }, [isOpen, options.length]);

    const handleSelect = (optionValue, isDisabled) => {
        if (isDisabled) return;
        onChange({ target: { value: optionValue } });
        setIsOpen(false);
    };

    const selectedOption = options.find(opt => opt.value === value);

    return (
        <div className={`custom-select ${className || ''}`} ref={selectRef}>
            <div
                className={`custom-select-trigger ${isOpen ? 'open' : ''}`}
                onClick={() => setIsOpen(!isOpen)}
            >
                <span>{selectedOption?.label || 'Select...'}</span>
                <span className="custom-select-arrow">▼</span>
            </div>
            {isOpen && (
                <div
                    className={`custom-select-options ${openUpward ? 'open-upward' : ''}`}
                    style={{
                        position: 'fixed',
                        top: openUpward ? 'auto' : `${dropdownPosition.top}px`,
                        bottom: openUpward ? `${dropdownPosition.bottom}px` : 'auto',
                        left: `${dropdownPosition.left}px`,
                        width: `${dropdownPosition.width}px`
                    }}
                >
                    {options.map((option) => (
                        <div
                            key={option.value}
                            className={`custom-select-option ${option.value === value ? 'selected' : ''} ${option.disabled ? 'disabled' : ''}`}
                            onClick={() => handleSelect(option.value, option.disabled)}
                        >
                            {option.label}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default CustomSelect;
